import BenchlingConfig from 'BenchlingConfig';

const GTM_SCRIPT = `\
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WBXT8P5S');
`;

export function isRequired(): boolean {
  return (
    (BenchlingConfig.LLM_ENABLE_PUBLIC_AI_TRIAL_TENANT ||
      BenchlingConfig.ANALYTICS_ENABLE_SIGNED_OUT_AI_MARKETO_GTM) &&
    !window.bootstrapUser
  );
}

export function initialize(): void {
  const script = document.createElement('script');
  const text = document.createTextNode(GTM_SCRIPT);
  script.appendChild(text);
  document.body.appendChild(script);
}
